export interface UpdateInviteInput {
  inviteId: string;
  status: string;
}
